import { FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms"
import {Component, Inject, Input} from "@angular/core"
import { ApiService } from "../../services/api.service"
import { TranslateService } from "../../services/translate.service"
import { AuthService } from "../../services/auth.service"
import { DialogButtonComponent } from "../buttons/dialog-button.component"
import { CommonModule } from "@angular/common"
import {BottomSheetService} from '../../services/bottom-sheet.service';
import {ActionButtonComponent} from '../buttons/action-button.component';
import {LoadingSpinnerComponent} from './loading-spinner-component';

export interface GiftcardEmailFormData {
  venueId: string;
  postId: string;
  email: string;
}


@Component({
  selector: 'app-giftcard-email',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    DialogButtonComponent,
    CommonModule,
    ActionButtonComponent,
    LoadingSpinnerComponent,
  ],
  template: `
    <div class="mt-1 relative">
      <div class="" [formGroup]="emailForm">
        <div class="mb-1 font-bold">{{getString("E-post")}}</div>
        <input
          type="email"
          formControlName="email"
          [placeholder]="getString('Ange e-post')"
          class="text-input"
        />
        <div *ngIf="emailControl.invalid && emailControl.touched" class="text-red-500 mt-2">
          {{getString('Ogiltig e-post')}}
        </div>

        <div *ngIf="errorMsg" class="mt-4 text-red-500">{{ errorMsg }}</div>

        <div class="text-theme-text3 font-bold my-8">
          {{getString("Tips: Om du har svårt att hitta presentkortet, kika i ditt spamfilter eller skräppost om den råkat hamna fel.")}}
        </div>
      </div>
      <div class="my-8 w-full">
        <app-action-button
          [text]="getString('Skicka')"
          [disabled]="emailControl.invalid || isWorking"
          [icon]="'fa-paper-plane'"
          [chevron]="false"
          (onClick)="send()">
        </app-action-button>
      </div>
      <div *ngIf="isWorking" class="absolute bottom-0 top-0 left-0 right-0 bg-white/50 flex items-center justify-center">
        <app-loading-spinner></app-loading-spinner>
      </div>
    </div>
  `
})
export class SendGiftcardEmailComponent {

  @Input() sheetData!: GiftcardEmailFormData;
  isWorking: boolean = false;
  emailForm!: FormGroup
  errorMsg?: string

  constructor(public api: ApiService, private translate: TranslateService, private auth: AuthService,
              private sheetService: BottomSheetService) {
  }

  ngOnInit() {
    this.emailForm = new FormGroup({
      email: new FormControl(this.sheetData.email || '', {
        nonNullable: true,
        validators: [Validators.required, Validators.email]
      }),
    }, {
      updateOn: 'change'
    })

  }

  getString(s: string) {
    return this.translate.getString(s)
  }

  get emailControl() {
    return this.emailForm.controls["email"]!
  }

  send() {
    this.isWorking = true
    const email = this.emailControl.value
    this.api.sendGiftcard(this.sheetData.venueId, this.sheetData.postId!, email).subscribe({
      next: () => {
        this.isWorking = false
        this.sheetService.popSheet();
      },
      error: err => {
        this.isWorking = false
        this.errorMsg = err?.message || this.getString("Något gick fel")
      }
    })
  }
}
